import { Injectable } from '@angular/core';
import { PersonalManager, PersonalManagersList } from '@my-account/const';
import { MyAccountActions, MyAccountSelectors, StateWithMyAccount } from '@my-account/data-access';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PersonalManagerService {
  constructor(private store: Store<StateWithMyAccount>) {}

  loadInfoManager(id: string): void {
    this.store.dispatch(new MyAccountActions.GetPersonalManagerConfirmation(id));
  }

  getInfoManager(): Observable<PersonalManager> {
    return this.store.select(MyAccountSelectors.getPersonalManagerConfirmationValue);
  }

  getApprovementManagerLoading(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.approveManagerLoading(id));
  }

  getApprovementManagerError(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.approveManagerError(id));
  }

  getApprovementManagerSuccess(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.approveManagerSuccess(id));
  }

  getRevocationManagerLoading(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.revokeManagerLoading(id));
  }

  getRevocationManagerError(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.revokeManagerError(id));
  }

  getRevocationManagerSuccess(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.revokeManagerSuccess(id));
  }

  getDeleteManagerLoading(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.deleteManagerLoading(id));
  }

  getDeleteManagerError(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.deleteManagerError(id));
  }

  getDeleteManagerSuccess(id: string): Observable<boolean> {
    return this.store.select(MyAccountSelectors.deleteManagerSuccess(id));
  }

  approveManager(id: string): void {
    this.store.dispatch(new MyAccountActions.ApprovePersonalManager(id));
  }

  revokeManager(id: string): void {
    this.store.dispatch(new MyAccountActions.RevokePersonalManager(id));
  }

  deleteManager(id: string): void {
    this.store.dispatch(new MyAccountActions.DeletePersonalManager(id));
  }

  loadManagersList(): void {
    this.store.dispatch(new MyAccountActions.LoadPersonalManagersList());
  }

  getManagersList(): Observable<PersonalManagersList> {
    return this.store.select(MyAccountSelectors.getPersonalManagersListValue);
  }

  getManagersListUnconfirmedFirst(): Observable<PersonalManagersList> {
    return this.getManagersList().pipe(
      map((managersList) => {
        if (!managersList) {
          return managersList;
        }

        const sortedManagers = [...managersList.personalManagers];
        sortedManagers.sort((a, b) => {
          if (a.confirmed && !b.confirmed) {
            return 1;
          }
          if (!a.confirmed && b.confirmed) {
            return -1;
          }

          return 0;
        });

        return {
          ...managersList,
          personalManagers: sortedManagers,
        };
      }),
    );
  }
}
